var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":_vm.title,"width":720,"visible":_vm.visible,"confirmLoading":_vm.confirmLoading,"maskClosable":false,"footer":false,"destroyOnClose":true},on:{"ok":_vm.handleSubmit,"cancel":_vm.handleCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }